import React, { useEffect } from 'react';
import { getProductReferrer } from 'app/utils/referrerTracker/referrers';
import { loadNotifyMeClearanceStatuses } from 'app/utils/globalDataHelpers';
import { fetchProducts } from './components/productList/productListActions';
import store from './productsStore';
import { SET_REFERRER_PRODUCT } from './components/productList/productListConstants';
import { getParamsFromUrl } from './components/facetsList/facetListUtils';

const { categoryId } = window.inlinePlp;

// TODO extract a container component which injects redux store properties to <ProductApp>
const productsHOC = WrappedComponent => props => {
  useEffect(() => {
    loadNotifyMeClearanceStatuses();

    const searchFragment = window.location.search.substr(1);
    if (searchFragment) {
      const { sort = [''], ...searchFacets } = getParamsFromUrl(searchFragment);
      store.dispatch({ type: 'URL_HASH_APPLIED', sort: sort[0], searchFacets });
    }

    const referrerProduct = getProductReferrer(categoryId);
    if (referrerProduct) {
      store.dispatch({
        type: SET_REFERRER_PRODUCT,
        page: referrerProduct.page,
        productId: referrerProduct.productId,
        isGridView: referrerProduct.isGridView,
      });
    }

    store.dispatch(fetchProducts({ withAnalytics: true, mustValidateURLParams: true })).then(json => {
      if (json) {
        // Display search result page banners after initial product fetch
        document.querySelector('.header__promo-wrapper').style.visibility = '';
      }
    });

    window.addEventListener('hashchange', onOptionsChange);

    return function cleanup() {
      window.removeEventListener('hashchange', onOptionsChange);
    };
  }, []);
  return <WrappedComponent {...props} />;
};

function onOptionsChange(event) {
  const changedQueryFragment = new URL(event.newURL).search.substr(1);
  const { sort = [''], ...searchFacets } = getParamsFromUrl(changedQueryFragment);
  store.dispatch({ type: 'URL_HASH_CHANGED', sort: sort[0], searchFacets });
  store.dispatch(
    fetchProducts({
      showLoader: true,
      withAnalytics: true,
      mustValidateURLParams: true,
    })
  );
}

export default productsHOC;
